import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-toolbar" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "mt-2 col-12 col-md-12" }
const _hoisted_6 = { class: "d-flex align-items-center" }
const _hoisted_7 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_8 = {
  class: "modal fade",
  ref: "downloadModalRef",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  id: "kt_modal_migrasi"
}
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"modal-dialog modal-dialog-centered mw-600px\"><div class=\"modal-content rounded\"><div class=\"modal-header py-2 border-0 justify-content-start\" style=\"background-color:#00a29c;\"><label class=\"fw-bold fs-2\" style=\"color:white;\">Migrasi PPDB</label></div><div class=\"modal-body scroll-y px-10 px-lg-15 pt-0 pb-5\"><div class=\"pt-8\"><h3 class=\"text-black\"> Apakah anda yakin akan melakukan migrasi sekolah untuk menggunakan fitur PPDB? </h3></div><div class=\"modal-footer\"><div class=\"m-2\" style=\"width:100%;text-align:center;\"><button style=\"width:20%;\" type=\"button\" class=\"btn btn-success\" data-bs-dismiss=\"modal\"> Ya </button>      <button style=\"width:20%;\" type=\"button\" class=\"btn btn-danger\" data-bs-dismiss=\"modal\"> Tidak </button></div></div></div></div></div>", 1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "card-body py-3" }
const _hoisted_12 = { class: "table-responsive" }
const _hoisted_13 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-110px; text-center" }, "No"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-110px; text-left" }, "Nama"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Jumlah Subscribe"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Jumlah Fitur"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Action")
  ])
], -1)
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = { class: "text-left" }
const _hoisted_18 = { class: "text-center" }
const _hoisted_19 = { class: "text-center" }
const _hoisted_20 = { class: "text-center" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/detail.svg",
  alt: ""
}, null, -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { key: 1 }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "6",
    style: {"text-align":"center"}
  }, "Tidak Ada Data")
], -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = { class: "row mt-5 mb-5" }
const _hoisted_28 = { class: "col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start" }
const _hoisted_29 = {
  class: "dataTables_length",
  id: "kt_customers_table_length"
}
const _hoisted_30 = ["label", "value"]
const _hoisted_31 = { class: "p-3" }
const _hoisted_32 = { class: "col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.widgetClasses, "card"])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control w-250px ps-15",
                  placeholder: "Cari Nama",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
                  onKeyup: _cache[1] || (_cache[1] = ($event: any) => (_ctx.eventDelaySearch()))
                }, null, 544), [
                  [_vModelText, _ctx.name]
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, _hoisted_10, 512),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("table", _hoisted_13, [
            _hoisted_14,
            (_ctx.tableData.length)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", _hoisted_16, _toDisplayString(index + 1), 1),
                      _createElementVNode("td", _hoisted_17, _toDisplayString(item.name), 1),
                      _createElementVNode("td", _hoisted_18, _toDisplayString(item.subscription_count), 1),
                      _createElementVNode("td", _hoisted_19, _toDisplayString(item.feature_count), 1),
                      _createElementVNode("td", _hoisted_20, [
                        (_ctx.role != 'ADMIN_CARD')
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              class: "symbol symbol-30px me-2",
                              "data-bs-toggle": "tooltip",
                              title: "Detail",
                              style: {"cursor":"pointer"},
                              onClick: ($event: any) => (
                      _ctx.$router.push(
                        '/superadmin/master-feature/school/edit/' + item._id
                      )
                    )
                            }, _hoisted_23, 8, _hoisted_21))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_24, _hoisted_26))
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("label", null, [
                _withDirectives(_createElementVNode("select", {
                  name: "kt_customers_table_length",
                  class: "form-select form-select-sm form-select-solid",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.paging.size) = $event)),
                  placeholder: "Per page",
                  onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changePageSize($event)))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paging.perPageOptions, (item) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: item,
                      label: item.toString(),
                      value: item
                    }, null, 8, _hoisted_30))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.paging.size]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_31, " Showing " + _toDisplayString(_ctx.from + 1) + " to " + _toDisplayString(_ctx.to) + " of " + _toDisplayString(_ctx.paging.totalElements) + " entries ", 1)
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createVNode(_component_Pagination, {
              startAt: true,
              paging: _ctx.paging,
              "max-visible-pages": 5,
              onNext: _ctx.nextPage,
              onPrev: _ctx.prevPage,
              onChange: _ctx.changePage
            }, null, 8, ["paging", "onNext", "onPrev", "onChange"])
          ])
        ])
      ])
    ], 2)
  ], 64))
}